/* eslint-disable */

import amplitude from "amplitude-js"

amplitude.getInstance().init(window.gon.amplitude_token, null, {
  includeUtm: true,
  includeReferrer: true,
  includeGclid: true,
  trackingOptions: {
    ip_address: false
  }
});

window.dataLayer = window.dataLayer || []
window.gtag = function() {
  window.dataLayer.push(arguments)
}
window.gtag("js", new Date())
window.gtag("locale", window.gon.locale)
window.gtag("config", window.gon.ga4_account);

// Google Tag Manager
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:'';j.async=true;j.src=
"//www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,"script","dataLayer",gon.google_tag_manager_container);
